import {
  AccountCircle,
  Lock,
  Visibility,
  VisibilityOff,
} from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Checkbox,
  Container,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import { observer } from "mobx-react";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import AppContainer from "src/components/AppContainer";
import css from "./forgotPassword.module.scss";

const ForgotPasswordPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");

  const onChangeEmail = (event) => {
    setEmail(event.target.value);
  };
  function validateForm() {
    return email.length > 0;
  }

  function onSubmit(event) {
    if (validateForm) {
      navigate("/login");
    }
    event.preventDefault();
  }

  useEffect(() => {}, []);

  return (
    <AppContainer className={css.appContainer}>
      <Container className={css.container}>
        <form onSubmit={onSubmit}>
          <Card sx={{ minWidth: 300, padding: "0" }} className={css.card}>
            <CardHeader title={t("forgotPasswordPage.title")}></CardHeader>
            <CardContent>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormLabel>{t("forgotPasswordPage.detail")}</FormLabel>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    id="username"
                    type="email"
                    variant="outlined"
                    placeholder={t("forgotPasswordPage.email")}
                    fullWidth
                    required
                    value={email}
                    onChange={onChangeEmail}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <CardActions className={css.cardAction}>
              <Button onClick={() => navigate("/login")}>
                {t("forgotPasswordPage.backBtn")}
              </Button>
              <Button type="submit" variant="contained" size="large">
                {t("forgotPasswordPage.submitBtn")}
              </Button>
            </CardActions>
          </Card>
        </form>
      </Container>
    </AppContainer>
  );
};
export default observer(ForgotPasswordPage);
